// extracted by mini-css-extract-plugin
export var sliderArrowLeft = "s_bx";
export var sliderArrowRight = "s_by";